module.exports = __webpack_public_path__ + "static/media/haichuanghui.f1cecba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo/haichuanghui.svg
// module id = 45
// module chunks = 6